import {
  standardCode,
  standardWithIconCode,
  inlineCode,
  featuredActionCode
} from './notificationsCode';

import {
  standardLayout,
  standardWithIconLayout,
  inlineLayout,
  actionLayout
} from './notificationsLayouts';

import styles from './notificationsSet.css';

const notificationsSet = [
  {
    component: standardLayout,
    codeTemplate: standardCode,
    previewClass: styles.preview,
    optionsGroup: [
      {
        label: 'Standard',
        options: [
          {label: 'Default', type: 'radio', options: {layout: 'standard', additionalMessage: null}},
          {label: 'With Additional Message', type: 'radio', options: {layout: 'standard', additionalMessage: 'Additional Message'}},
          {label: 'With Link', type: 'radio', options: {layout: 'withLink', additionalMessage: null}}
        ]
      }
    ]
  },
  {
    component: standardWithIconLayout,
    codeTemplate: standardWithIconCode,
    previewClass: styles.preview,
    optionsGroup: [
      {
        label: 'With Icon',
        options: [
          {label: 'Default', type: 'radio', options: {}},
        ]
      }
    ]
  },
  {
    component: inlineLayout,
    codeTemplate: inlineCode,
    modalPreviewClassName: 'with-padding',
    imagePath: 'inline-notification.png',
    optionsGroup: [
      {
        label: 'Landing',
        options: [
          {label: 'Default', type: 'radio', options: {}},
        ]
      }
    ]
  },
  {
    component: actionLayout,
    codeTemplate: featuredActionCode,
    modalPreviewClassName: 'with-padding',
    imagePath: 'action-notification.png',
    optionsGroup: [
      {
        label: 'Featured Actions',
        options: [
          {label: 'Default', type: 'radio', options: {}},
        ]
      }
    ]
  }
];

export default notificationsSet;



// WEBPACK FOOTER //
// ./src/containers/components/Notification/constants/notificationsSet.js